export default [
    {
        path: 'atendimento-triagem',
        component: () => import(
            /* webpackChunkName: 'pronto-atendimento-atendimento-triagem' */
            '@/views/pronto-atendimento/atendimento-triagem/Index'
        ),
        redirect: 'atendimento-triagem/index',
        children: [
            {
                name: 'pronto-atendimento-atendimento-triagem-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-atendimento-triagem' */
                    '@/views/pronto-atendimento/atendimento-triagem/List.vue'),
            },
            {
                name: 'pronto-atendimento-atendimento-triagem-create',
                path: 'create/:id/:plantaoId',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-atendimento-triagem' */
                    '@/views/pronto-atendimento/atendimento-triagem/Form'
                ),
            },
        ]
    }
]